import { useQuery } from "react-query"
import {
  getDonationsForPost,
  type DonationsIndexResponse,
} from "../requests/tips"

/**
 * Hook to fetch all completed donations for a post (band management view)
 *
 * @param postId - The ID of the post to get donations for
 * @param enabled - Whether the query should run
 */
export function useDonationsForPost(postId: number | null, enabled = true) {
  return useQuery<DonationsIndexResponse, Error>(
    ["donations", postId],
    () => getDonationsForPost(postId!),
    {
      enabled: enabled && postId !== null,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  )
}
